import { render, staticRenderFns } from "./LowMarginWarnings.vue?vue&type=template&id=57eaed27"
import script from "./LowMarginWarnings.vue?vue&type=script&lang=js"
export * from "./LowMarginWarnings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports